import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from './user';
import { ApiResponse } from '../../../../shared/api-response';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private rootUrl = `${environment.cemsRootUrl}/users`;
  
  constructor(private http: HttpClient) {}

  createUser(user: User): Observable<ApiResponse<User>> {
    return this.http.post<ApiResponse<User>>(this.rootUrl, user);
  }

  updateUser(user: User): Observable<ApiResponse<User>> {
    return this.http.put<ApiResponse<User>>(`${this.rootUrl}/${user.id}`, user);
  }

  deleteUser(id: number): Observable<ApiResponse<null>> {
    return this.http.delete<ApiResponse<null>>(`${this.rootUrl}/${id}`);
  }

  getUsers(): Observable<ApiResponse<User[]>> {
    return this.http.get<ApiResponse<User[]>>(this.rootUrl);
  }

  getUserById(id: number): Observable<ApiResponse<User | null>> {
    return this.http.get<ApiResponse<User | null>>(`${this.rootUrl}/${id}`);
  }

  getUserByOhioId(ohioId: string): Observable<ApiResponse<User | null>> {
    return this.http.get<ApiResponse<User | null>>(`${this.rootUrl}/ohioId/${ohioId}`);
  }

  getUsersWithAgencyCount(): Observable<ApiResponse<User[]>> {
    return this.http.get<ApiResponse<User[]>>(`${this.rootUrl}/withAgencyCount`);
  }

  toggleActiveForNonAdmins(isActive: boolean): Observable<any> {
    return this.http.put<any>(`${this.rootUrl}/toggleActiveForNonAdmins?isActive=${isActive}`, null);
  }
}